import { APIService } from "./api";
import { API } from "@/lib/api";
import { ReadPayrollType, WritePayrollType } from "@/types/payrollType";

export const PayrollTypesService = new APIService<
  ReadPayrollType,
  WritePayrollType
>(API.PayrollTypes);
export const fetchPayrollTypeList = PayrollTypesService.getList;
export const fetchPayrollType = PayrollTypesService.get;
export const createPayrollType = PayrollTypesService.post;
export const updatePayrollType = PayrollTypesService.patch;
